module.exports = __webpack_public_path__ + "static/media/6-ANTI-POLICE-BRUTALITY-1.f861f9e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/6-ANTI-POLICE-BRUTALITY-1.jpg
// module id = 142
// module chunks = 0